import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.loadingSubject.asObservable();
  private activeRequests = 0; // Counter for active requests
  private hideTimeout: any;

  show(): void {
    clearTimeout(this.hideTimeout);
    this.activeRequests++;
    if (this.activeRequests > 0 && !this.loadingSubject.getValue()) {
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
    clearTimeout(this.hideTimeout);
    this.activeRequests = Math.max(0, this.activeRequests - 1); // Prevent negative counter
    if (this.activeRequests === 0) {
      this.hideTimeout = setTimeout(() => {
        this.loadingSubject.next(false);
      }, 600); // 0.6 seconds delay
    }
  }
}
